import { render, staticRenderFns } from "./DeleteCouponRuleFee.vue?vue&type=template&id=35faf824&scoped=true"
import script from "./DeleteCouponRuleFee.vue?vue&type=script&lang=js"
export * from "./DeleteCouponRuleFee.vue?vue&type=script&lang=js"
import style0 from "./DeleteCouponRuleFee.vue?vue&type=style&index=0&id=35faf824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35faf824",
  null
  
)

export default component.exports